export const sobActualsTableTranslation = {
  /**
   * Q1
   */
  q1: 'jbp-h2-review-sob-actuals-table-q1',

  /**
   * Q2
   */
  q2: 'jbp-h2-review-sob-actuals-table-q2',

  /**
   * Q3
   */
  q3: 'jbp-h2-review-sob-actuals-table-q3',

  /**
   * Q4
   */
  q4: 'jbp-h2-review-sob-actuals-table-q4',

  /**
   * Total
   */
  total: 'jbp-h2-review-sob-actuals-table-total',

  /**
   * Overall
   */
  overall: 'jbp-h2-review-sob-actuals-table-overall',

  /**
   * Finance
   */
  finance: 'jbp-h2-review-sob-actuals-table-finance',

  /**
   * Expand overall section
   */
  expandOverallSection: 'jbp-h2-review-sob-actuals-table-expand-overall-section',

  /**
   * Collapse overall section
   */
  collapseOverallSection: 'jbp-h2-review-sob-actuals-table-collapse-overall-section',

  /**
   * Actuals
   */
  actuals: 'jbp-h2-review-sob-actuals-table-actuals',

  /**
   * Planned
   */
  planned: 'jbp-h2-review-sob-actuals-table-planned',

  /**
   * Actuals YoY
   */
  actualsYoy: 'jbp-h2-review-sob-actuals-table-actuals-yoy',

  /**
   * Plan vs LY Actuals YoY
   */
  planVsLyActualsYoy: 'jbp-h2-review-sob-actuals-table-plan-vs-ly-actuals-yoy',

  /**
   * Plan achievement
   */
  planAchievement: 'jbp-h2-review-sob-actuals-table-plan-achievement',

  /**
   * SoB, %
   */
  sobPercent: 'jbp-h2-review-sob-actuals-table-sob-percent',

  /**
   * JBP Plan
   */
  jbpPlan: 'jbp-h2-review-sob-actuals-table-jbp-plan',

  /**
   * no plan
   */
  noPlan: 'jbp-planning-no-plan',

  /**
   * no plan
   */
  noPlanSwitcher: 'jbp-planning-no-plan-switcher',
}
